export const message = {
  savePdfTemplateSuccess: 'PDF Template successfully saved',
  publishPdfTemplateSuccess: 'PDF Template successfully published'
}